(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory() : typeof define === 'function' && define.amd ? define(factory) : factory();
})(this, function () {
  'use strict';

  function unwrapExports(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }
  function createCommonjsModule(fn, module) {
    return module = {
      exports: {}
    }, fn(module, module.exports), module.exports;
  }
  var strictUriEncode = function strictUriEncode(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
      return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
  };

  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  /* eslint-disable no-unused-vars */
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }

      // Detect buggy property enumeration order in older V8 versions.

      // https://bugs.chromium.org/p/v8/issues/detail?id=4118
      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
      test1[5] = 'de';
      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });
      if (order2.join('') !== '0123456789') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }
      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }
  var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);
      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }
    return to;
  };
  function encoderForArrayFormat(opts) {
    switch (opts.arrayFormat) {
      case 'index':
        return function (key, value, index) {
          return value === null ? [encode(key, opts), '[', index, ']'].join('') : [encode(key, opts), '[', encode(index, opts), ']=', encode(value, opts)].join('');
        };
      case 'bracket':
        return function (key, value) {
          return value === null ? encode(key, opts) : [encode(key, opts), '[]=', encode(value, opts)].join('');
        };
      default:
        return function (key, value) {
          return value === null ? encode(key, opts) : [encode(key, opts), '=', encode(value, opts)].join('');
        };
    }
  }
  function parserForArrayFormat(opts) {
    var result;
    switch (opts.arrayFormat) {
      case 'index':
        return function (key, value, accumulator) {
          result = /\[(\d*)\]$/.exec(key);
          key = key.replace(/\[\d*\]$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = {};
          }
          accumulator[key][result[1]] = value;
        };
      case 'bracket':
        return function (key, value, accumulator) {
          result = /(\[\])$/.exec(key);
          key = key.replace(/\[\]$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          } else if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }
          accumulator[key] = [].concat(accumulator[key], value);
        };
      default:
        return function (key, value, accumulator) {
          if (accumulator[key] === undefined) {
            accumulator[key] = value;
            return;
          }
          accumulator[key] = [].concat(accumulator[key], value);
        };
    }
  }
  function encode(value, opts) {
    if (opts.encode) {
      return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
    }
    return value;
  }
  function keysSorter(input) {
    if (Array.isArray(input)) {
      return input.sort();
    } else if (typeof input === 'object') {
      return keysSorter(Object.keys(input)).sort(function (a, b) {
        return Number(a) - Number(b);
      }).map(function (key) {
        return input[key];
      });
    }
    return input;
  }
  var extract = function extract(str) {
    return str.split('?')[1] || '';
  };
  var parse = function parse(str, opts) {
    opts = objectAssign({
      arrayFormat: 'none'
    }, opts);
    var formatter = parserForArrayFormat(opts);

    // Create an object with no prototype
    // https://github.com/sindresorhus/query-string/issues/47
    var ret = Object.create(null);
    if (typeof str !== 'string') {
      return ret;
    }
    str = str.trim().replace(/^(\?|#|&)/, '');
    if (!str) {
      return ret;
    }
    str.split('&').forEach(function (param) {
      var parts = param.replace(/\+/g, ' ').split('=');
      // Firefox (pre 40) decodes `%3D` to `=`
      // https://github.com/sindresorhus/query-string/pull/37
      var key = parts.shift();
      var val = parts.length > 0 ? parts.join('=') : undefined;

      // missing `=` should be `null`:
      // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
      val = val === undefined ? null : decodeURIComponent(val);
      formatter(decodeURIComponent(key), val, ret);
    });
    return Object.keys(ret).sort().reduce(function (result, key) {
      var val = ret[key];
      if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
        // Sort object keys, not values
        result[key] = keysSorter(val);
      } else {
        result[key] = val;
      }
      return result;
    }, Object.create(null));
  };
  var stringify = function stringify(obj, opts) {
    var defaults = {
      encode: true,
      strict: true,
      arrayFormat: 'none'
    };
    opts = objectAssign(defaults, opts);
    var formatter = encoderForArrayFormat(opts);
    return obj ? Object.keys(obj).sort().map(function (key) {
      var val = obj[key];
      if (val === undefined) {
        return '';
      }
      if (val === null) {
        return encode(key, opts);
      }
      if (Array.isArray(val)) {
        var result = [];
        val.slice().forEach(function (val2) {
          if (val2 === undefined) {
            return;
          }
          result.push(formatter(key, val2, result.length));
        });
        return result.join('&');
      }
      return encode(key, opts) + '=' + encode(val, opts);
    }).filter(function (x) {
      return x.length > 0;
    }).join('&') : '';
  };
  var queryString = {
    extract: extract,
    parse: parse,
    stringify: stringify
  };
  var cookies = createCommonjsModule(function (module, exports) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    /*\
    |*|
    |*|  :: cookies.js ::
    |*|
    |*|  A complete cookies reader/writer framework with full unicode support.
    |*|
    |*|  Revision #1 - September 4, 2014
    |*|
    |*|  https://developer.mozilla.org/en-US/docs/Web/API/document.cookie
    |*|  https://developer.mozilla.org/User:fusionchess
    |*|
    |*|  This framework is released under the GNU Public License, version 3 or later.
    |*|  http://www.gnu.org/licenses/gpl-3.0-standalone.html
    |*|
    |*|  Syntaxes:
    |*|
    |*|  * docCookies.setItem(name, value[, end[, path[, domain[, secure]]]])
    |*|  * docCookies.getItem(name)
    |*|  * docCookies.removeItem(name[, path[, domain]])
    |*|  * docCookies.hasItem(name)
    |*|  * docCookies.keys()
    |*|
    \*/

    var docCookies = {
      setBasePathEncodedItem: function setBasePathEncodedItem(name, value) {
        if (window && window.location && window.location.hostname) this.setItem(name, value, window.location.hostname.substring(window.location.hostname.indexOf(".")));
      },
      getItem: function getItem(sKey) {
        if (!sKey) {
          return null;
        }
        return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
      },
      setItem: function setItem(sKey, sValue, sDomain, vEnd, sPath, bSecure) {
        if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
          return false;
        }
        var sExpires = "";
        if (vEnd) {
          switch (vEnd.constructor) {
            case Number:
              sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
              break;
            case String:
              sExpires = "; expires=" + vEnd;
              break;
            case Date:
              sExpires = "; expires=" + vEnd.toUTCString();
              break;
          }
        }
        document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
        return true;
      },
      removeItem: function removeItem(sKey, sPath, sDomain) {
        if (!this.hasItem(sKey)) {
          return false;
        }
        document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
        return true;
      },
      hasItem: function hasItem(sKey) {
        if (!sKey) {
          return false;
        }
        return new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test(document.cookie);
      },
      keys: function keys() {
        var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
        for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
          aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
        }
        return aKeys;
      }
    };
    exports.default = docCookies;
  });
  unwrapExports(cookies);
  var dist = createCommonjsModule(function (module, exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    exports.read = read;
    exports.toQueryString = toQueryString;
    exports.writeJson = writeJson;
    exports.write = write;
    exports.seed = seed;
    var _queryString2 = _interopRequireDefault(queryString);
    var _cookies2 = _interopRequireDefault(cookies);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    var nameCookie = 'context';

    //object => string
    function encode64(body) {
      return btoa(JSON.stringify(body));
    }

    //string => object
    function decode64(body) {
      return JSON.parse(atob(body));
    }
    function read() {
      seed();
      return doRead();
    }

    //void => object
    function doRead() {
      var context = _cookies2.default.getItem(nameCookie);
      if (context && typeof context === 'string') {
        return decode64(context);
      } else if (context && (typeof context === 'undefined' ? 'undefined' : _typeof(context)) === 'object') {
        return context;
      }
      return {};
    }

    //void => string
    function toQueryString() {
      var context = read();
      if (context) {
        var newContext = {};
        Object.keys(context).map(function (name, index) {
          newContext["c_" + name] = context[name];
        });
        return _queryString2.default.stringify(newContext);
      }
    }

    //object => object
    function writeJson(body) {
      var context = doRead();
      if (body && (typeof body === 'undefined' ? 'undefined' : _typeof(body)) === 'object') {
        Object.keys(body).forEach(function (key) {
          var value = body[key];
          if (value) context[key] = value;
        });
        _cookies2.default.setBasePathEncodedItem(nameCookie, encode64(context));
      }
      return context;
    }

    //string, any => object
    function write(key, value) {
      var context = doRead();
      if (key && typeof key === 'string' && value && context && (typeof context === 'undefined' ? 'undefined' : _typeof(context)) === 'object') {
        context[key] = value;
        _cookies2.default.setBasePathEncodedItem(nameCookie, encode64(context));
      }
      return context;
    }

    //void => object
    function seed() {
      var context = {
        "b2wSid": _cookies2.default.getItem('B2W-SID'),
        "b2wUid": _cookies2.default.getItem('B2W-UID'),
        "b2wPid": _cookies2.default.getItem('B2W-PID'),
        "b2wOpn": _cookies2.default.getItem('b2wOpn'),
        "b2wDeviceType": _cookies2.default.getItem('b2wDeviceType'),
        "b2wChannel": _cookies2.default.getItem('b2wChannel'),
        'b2wEPar': _cookies2.default.getItem('b2wEPar'),
        'customerId': _cookies2.default.getItem('customer.id'),
        'salesSolution': _cookies2.default.getItem('salesSolution')
      };
      writeJson(context);
      return context;
    }
  });
  unwrapExports(dist);
  var dist_2 = dist.toQueryString;
  var shouldRunLog = function shouldRunLog() {
    try {
      var logSpectre = window.top.location.search.replace('?', '').split('&').indexOf('log=true');
      var log = !!window && !!window.top && !!window.top.localStorage && window.top.localStorage.getItem('saika-log');
      return logSpectre !== -1 || log && log !== '';
    } catch (exception) {
      console.error(exception);
      return;
    }
  };
  var emit = function emit(value) {
    return shouldRunLog() && !!console && typeof console.info === 'function' && console.info(value);
  };
  var dispatchFormatted = function dispatchFormatted(_ref) {
    var eventName = _ref.eventName,
      status = _ref.status,
      data = _ref.data,
      dispatchApi = _ref.dispatchApi;
    return emit('[SaikaClient] - Dispatch API :: ' + dispatchApi + ' - Dispatch Event :: ' + eventName + ' :: ' + status + ' :: ', data);
  };
  var getBrand = function getBrand(origin) {
    if (/(americanas.com.br)$/.test(origin)) {
      return 'acom';
    } else if (/(submarino.com.br)$/.test(origin)) {
      return 'suba';
    } else if (/(shoptime.com.br)$/.test(origin)) {
      return 'shop';
    } else if (/(soubarato.com.br)$/.test(origin)) {
      return 'soub';
    }
    return null;
  };
  var requestSaika = function requestSaika(data, evtName, evtNameSpace) {
    var contextQS = dist_2();

    // Verify url
    var saikaUrl;
    if (!evtNameSpace) {
      saikaUrl = 'https://saika-v2.b2w.io/event/' + evtName + (contextQS !== '' ? '?' + contextQS : '');
    } else {
      saikaUrl = 'https://saika-v3.b2w.io/event/' + evtNameSpace + '/' + evtName + (contextQS !== '' ? '?' + contextQS : '');
    }

    // SendBeaconevtName
    if (window.navigator.sendBeacon) {
      var status = navigator.sendBeacon(saikaUrl, data.body);
      dispatchFormatted({
        eventName: evtName,
        status: status ? 'success' : 'error',
        data: data.body,
        dispatchApi: 'sendBeacon'
      });
      return;
    }

    // Fetch API
    if (!navigator.sendBeacon && window.fetch) {
      fetch(saikaUrl, data, evtName).then(function (res) {
        return dispatchFormatted({
          eventName: evtName,
          status: 'success',
          data: data.body,
          dispatchApi: 'fetch'
        });
      }).catch(function (err) {
        return dispatchFormatted({
          eventName: evtName,
          status: 'error',
          data: data.body,
          dispatchApi: 'fetch'
        });
      });
      return;
    }

    // XMLHttpRequest
    if (!navigator.sendBeacon && !window.fetch) {
      var http = new XMLHttpRequest();
      var result = void 0;
      http.open('POST', saikaUrl);
      http.setRequestHeader('Content-Type', 'application/json');
      result = http.send(data.body);
      dispatchFormatted({
        eventName: evtName,
        status: result ? 'success' : 'error',
        data: data.body,
        dispatchApi: 'XMLHttpRequest'
      });
      return;
    }
  };
  function getOrigin() {
    try {
      return window.top.location.origin;
    } catch (e) {
      return document.referrer;
    }
  }
  var brand = getBrand(getOrigin()) || 'acom';
  var setEventId = function setEventId() {
    var bigTimeRandom = Math.floor(Math.random() * 10000 + 1);
    var shortTimeRandom = Math.floor(Math.random() * 100 + 1);
    var time = new Date().getTime();
    return (bigTimeRandom + shortTimeRandom + time).toString();
  };
  var saikaClient = function saikaClient(dataSaika) {
    if (!dataSaika) return null;
    var source = dataSaika.source,
      eventName = dataSaika.eventName,
      eventNameSpace = dataSaika.eventNameSpace,
      id = dataSaika.id,
      body = dataSaika.body,
      references = dataSaika.references;
    if (eventNameSpace && (!eventName || !brand)) {
      //v3
      return null;
    } else if (!eventNameSpace && (!source || !eventName || !brand)) {
      return null;
    }
    var data = {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: !id || id === null || id === undefined ? setEventId() : id.toString(),
        brand: brand,
        source: source,
        data: body || {},
        references: references || {}
      })
    };
    return requestSaika(data, eventName, eventNameSpace);
  };
  exports.saikaClient = saikaClient;
});